/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_FamilyGroupMemberRequest } from '../models/billing_FamilyGroupMemberRequest';
import type { billing_FamilyGroupMemberResponse } from '../models/billing_FamilyGroupMemberResponse';
import type { billing_FamilyGroupPickerListResponse } from '../models/billing_FamilyGroupPickerListResponse';
import type { billing_FamilyGroupRequest } from '../models/billing_FamilyGroupRequest';
import type { billing_FamilyGroupResponse } from '../models/billing_FamilyGroupResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FamilyGroupsService {
    /**
     * List family groups for the family-account picker
     * One page of the organisation's family groups with members, children, debtor balances and lifecycle. Used by the contract wizard (pass childId: groups that share a parent contact with the child sort first) and by the Payments-tab family-account picker. Order: sharesParent first, then current groups, then by family name.
     * @param search Substring of the family name or a child's internal id / first / last name (accent and case insensitive, max 100 characters)
     * @param childId Child whose parent contacts drive sharesParent
     * @param excludeFamilyGroupId Family group to leave out (e.g. the contract's current one)
     * @param limit Page size (default 20, values above 100 are clamped to 100)
     * @param offset Rows to skip (default 0)
     * @returns billing_FamilyGroupPickerListResponse OK
     * @throws ApiError
     */
    public static getApiV1FamilyGroups(
        search?: string,
        childId?: string,
        excludeFamilyGroupId?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<billing_FamilyGroupPickerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/family-groups',
            query: {
                'search': search,
                'childId': childId,
                'excludeFamilyGroupId': excludeFamilyGroupId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid query parameter`,
                401: `Unauthorized`,
                403: `Organization ID not found in token or module access denied`,
                404: `Child not found`,
                500: `Failed to list family groups`,
            },
        });
    }
    /**
     * Create a new family group with members
     * Create a new family group with initial members
     * @param request Family group details
     * @returns billing_FamilyGroupResponse Created
     * @throws ApiError
     */
    public static postApiV1FamilyGroups(
        request: billing_FamilyGroupRequest,
    ): CancelablePromise<billing_FamilyGroupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/family-groups',
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                403: `Organization ID not found in token`,
                422: `Unprocessable entity (invalid billing type, split percentages, or unified email)`,
                500: `Failed to create family group`,
            },
        });
    }
    /**
     * Delete a family group
     * Soft delete a family group
     * @param id Family Group ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1FamilyGroups(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/family-groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing family group ID`,
                403: `Organization ID not found in token`,
                404: `Family group not found`,
                500: `Failed to delete family group`,
            },
        });
    }
    /**
     * Get a family group by ID
     * Get a family group by ID with members
     * @param id Family Group ID
     * @returns billing_FamilyGroupResponse OK
     * @throws ApiError
     */
    public static getApiV1FamilyGroups1(
        id: string,
    ): CancelablePromise<billing_FamilyGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/family-groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing family group ID`,
                403: `Organization ID not found in token`,
                404: `Family group not found`,
                500: `Failed to get family group`,
            },
        });
    }
    /**
     * Update a family group
     * Update an existing family group
     * @param id Family Group ID
     * @param request Family group updates
     * @returns billing_FamilyGroupResponse OK
     * @throws ApiError
     */
    public static putApiV1FamilyGroups(
        id: string,
        request: billing_FamilyGroupRequest,
    ): CancelablePromise<billing_FamilyGroupResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/family-groups/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                403: `Organization ID not found in token`,
                404: `Family group not found`,
                500: `Failed to update family group`,
            },
        });
    }
    /**
     * Add a member to a family group
     * Add a new member to an existing family group
     * @param id Family Group ID
     * @param request Member details
     * @returns billing_FamilyGroupMemberResponse Created
     * @throws ApiError
     */
    public static postApiV1FamilyGroupsMembers(
        id: string,
        request: billing_FamilyGroupMemberRequest,
    ): CancelablePromise<billing_FamilyGroupMemberResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/family-groups/{id}/members',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request or validation failed`,
                403: `Organization ID not found in token`,
                404: `Family group not found`,
                500: `Failed to add member`,
            },
        });
    }
    /**
     * Remove a member from a family group
     * Remove an existing member from a family group
     * @param id Family Group ID
     * @param memberId Member ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1FamilyGroupsMembers(
        id: string,
        memberId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/family-groups/{id}/members/{memberId}',
            path: {
                'id': id,
                'memberId': memberId,
            },
            errors: {
                400: `Missing family group ID or member ID`,
                403: `Organization ID not found in token`,
                404: `Member not found`,
                500: `Failed to remove member`,
            },
        });
    }
}
